import { Check as CheckIcon } from '@mui/icons-material';
import { Stack, Box } from '@mui/material';
import React from 'react';

import { SizingMultiplier, Typography } from '@ocx/ui';

export type LocationSelectorItemProps = {
  icon: React.ReactNode;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  isSelected: boolean;
  onClick: () => void;
};

const ITEM_HEIGHT = 72;
const ICON_SIZE = 24;

export const LocationSelectorItem = ({ icon, title, subtitle, isSelected, onClick }: LocationSelectorItemProps) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={0}
      sx={{
        minHeight: ITEM_HEIGHT,
        cursor: 'pointer',
      }}
      onClick={onClick}>
      <Box width={ICON_SIZE} height={ICON_SIZE} color={isSelected ? 'primary.main' : 'text.secondary'}>
        {icon}
      </Box>

      <Stack
        direction="column"
        ml={SizingMultiplier.md}
        py={SizingMultiplier.sm}
        pr={SizingMultiplier.xs}
        sx={{ flexGrow: 1, justifyContent: 'center' }}>
        <Stack direction="row" alignItems="center">
          <Typography
            variant="body1"
            sx={{
              flexGrow: 1,
              fontWeight: isSelected ? 'bold' : 'normal',
              color: isSelected ? 'primary.main' : 'text.primary',
            }}>
            {title}
          </Typography>
        </Stack>

        {subtitle && (
          <Typography variant="body2" color={isSelected ? 'primary.main' : 'text.secondary'}>
            {subtitle}
          </Typography>
        )}
      </Stack>

      {isSelected && <CheckIcon color="primary" />}
    </Stack>
  );
};
